<script setup>
    const props = defineProps({
        content: String,
        index: Number,
        title: String,
    })
</script>

<template>
    <li class="glossary-item">
        <p class="title" v-html="title" />
        <p class="excerpt" v-html="content" />
    </li>
</template>

<script>
    export default {
        name: "Glossary Item"
    }
</script>

<style scoped lang="scss">
    .excerpt {
        margin: 5px 0;
    }
</style>
